// import React, {

//   useCallback,

//   useEffect,

//   useMemo,

//   useState,

// } from "react";

// import { useNavigate } from "react-router-dom";

// import AdminSidebar from "./AdminSidebar";

// import AdminTopbar from "./Admintopbar";

// import {

//   getStudents,

//   getSchedules,

//   getAdminRegistrations,

//   getAdminExams,


//   normalizeDate,

//   getStudentDisplayName,

// } from "../api/adminclient";

// const PAGE_SIZE = 10;

// const todayISO = () => {

//   const date = new Date();

//   const month = String(date.getMonth() + 1).padStart(2, "0");

//   const day = String(date.getDate()).padStart(2, "0");

//   return `${date.getFullYear()}-${month}-${day}`;

// };

// const initialsOf = (name) =>

//   (name || "?")

//     .split(/\s+/)

//     .filter(Boolean)

//     .slice(0, 2)

//     .map((part) => part[0].toUpperCase())

//     .join("") || "?";

// export default function AdminTodaysExams() {

//   const navigate = useNavigate();

//   const [purchases, setPurchases] = useState([]);

//   const [students, setStudents] = useState([]);

//   const [loading, setLoading] = useState(true);

//   const [error, setError] = useState("");

//   const [search, setSearch] = useState("");

//   const [courseFilter, setCourseFilter] = useState("All");

//   const [page, setPage] = useState(1);

//   const prettyToday = new Date().toLocaleDateString(undefined, {
//     weekday: "long",
//     day: "numeric",
//     month: "long",
//     year: "numeric",
//   });

//   // Load bookings and students from the existing API client.

//   const load = useCallback(async () => {

//   setLoading(true);

//   setError("");

//   try {

//     const [

//       studentsResponse,

//       schedulesResponse,

//       registrationsResponse,

//       examsResponse,


//     ] = await Promise.all([

//       getStudents(),

//       getSchedules(),

//       getAdminRegistrations(),

//       getAdminExams(),


//     ]);

//     const toArray = (response) => {

//       const data = response?.data;

//       if (Array.isArray(data)) return data;

//       if (Array.isArray(data?.results)) return data.results;

//       return [];

//     };

//     setStudents(toArray(studentsResponse));

//     // Build booking rows from Django registrations and schedules.

//     const schedules = toArray(schedulesResponse);

//     const registrations = toArray(registrationsResponse);

//     const exams = toArray(examsResponse);


//     const getRelatedId = (value) => {

//       if (value && typeof value === "object") {

//         return value.id ?? value.pk ?? value.examId ?? value.exam_id ?? null;

//       }

//       return value ?? null;

//     };

//     const getScheduleId = (registration) =>

//       getRelatedId(

//         registration.schedule ??

//         registration.scheduleId ??

//         registration.schedule_id

//       );

//     const getStudentId = (registration) =>

//       getRelatedId(

//         registration.student ??

//         registration.studentId ??

//         registration.student_id ??

//         registration.user ??

//         registration.userId ??

//         registration.user_id

//       );

//     const getExamId = (record) =>

//       getRelatedId(

//         record.exam ??

//         record.examId ??

//         record.exam_id

//       );

//     const getScheduleDate = (schedule) =>

//       normalizeDate(

//         schedule.exam_date ??

//         schedule.examDate ??

//         schedule.date

//       );

//     const today = todayISO();

//     const rows = registrations

//       .map((registration) => {

//         const scheduleId = getScheduleId(registration);

//         const schedule = schedules.find(

//           (item) =>

//             String(item.id ?? item.pk) === String(scheduleId)

//         );

//         if (!schedule || getScheduleDate(schedule) !== today) {

//           return null;

//         }

//         const examId = getExamId(schedule);

//         const exam =

//           exams.find(

//             (item) =>

//               String(item.id ?? item.pk) === String(examId)

//           ) ??

//           (schedule.exam && typeof schedule.exam === "object"

//             ? schedule.exam

//             : null);

//         const studentId = getStudentId(registration);

//         const student =

//           studentsResponse &&

//           toArray(studentsResponse).find(

//             (item) =>

//               String(item.id ?? item.pk) === String(studentId)

//           );

//         return {

//           id: registration.id ?? registration.pk,

//           userId: studentId,

//           studentName: student

//             ? getStudentDisplayName(student)

//             : registration.studentName ??

//               registration.student_name ??

//               "",

//           studentEmail: student?.email ?? registration.email ?? "",

//           mobile: student?.mobile ?? registration.mobile ?? "",

//           courseId: exam?.courseId ?? exam?.course_id ?? "",

//           courseName:

//             exam?.name ??

//             exam?.title ??

//             schedule.exam_name ??

//             schedule.examName ??

//             "Scheduled Exam",

//           examDate: getScheduleDate(schedule),

//           registration,

//           schedule,

//         };

//       })

//       .filter(Boolean);

//     setPurchases(rows);

//   } catch (err) {

//     console.error("Today's Exams Django API error:", err);

//     console.error("Status:", err.response?.status);

//     console.error("Response:", err.response?.data);

//     setError(

//       err.response

//         ? `Django API error ${err.response.status}. Check the failed request in the browser Network tab.`

//         : "Cannot connect to Django. Check that the backend server is running."

//     );

//     setStudents([]);

//     setPurchases([]);

//   } finally {

//     setLoading(false);

//   }

// }, []);

//   // Load Django data when the page first mounts.
//   // Without this effect, load() is defined but never called automatically.
//   useEffect(() => {
//     load();
//   }, [load]);

//   // Match bookings whose exam date is today.

//   const today = todayISO();

// const todaysRows = useMemo(() => {

//   return purchases

//     .filter((purchase) => normalizeDate(purchase.examDate) === today)

//     .map((purchase) => {

//       const student = students.find(

//         (item) =>

//           String(item.id ?? item.pk) === String(purchase.userId)

//       );

//       return {

//         purchase,

//         student: student ?? {

//           id: purchase.userId,

//           email: purchase.studentEmail,

//           mobile: purchase.mobile,

//           fullName: purchase.studentName,

//         },

//         name:

//           purchase.studentName ||

//           (student ? getStudentDisplayName(student) : null),

//       };

//     });

// }, [purchases, students, today]);

//   // Build the course dropdown from today's bookings.

//   const courseOptions = useMemo(() => {

//     const courseMap = new Map();

//     todaysRows.forEach(({ purchase }) => {

//       const id = String(

//         purchase.courseId ?? purchase.courseName ?? "unknown"

//       );

//       if (!courseMap.has(id)) {

//         courseMap.set(id, {

//           id,

//           name: purchase.courseName || `Course ${id}`,

//         });

//       }

//     });

//     return Array.from(courseMap.values());

//   }, [todaysRows]);

//   // Search by student name, email, mobile, or course.

//   const filtered = useMemo(() => {

//     const query = search.trim().toLowerCase();

//     return todaysRows.filter((row) => {

//       const courseId = String(

//         row.purchase.courseId ?? row.purchase.courseName ?? "unknown"

//       );

//       const matchesCourse =

//         courseFilter === "All" || courseId === courseFilter;

//       const matchesSearch =

//         !query ||

//         row.name?.toLowerCase().includes(query) ||

//         row.student?.email?.toLowerCase().includes(query) ||

//         String(row.student?.mobile ?? "").includes(query) ||

//         String(row.purchase.courseName ?? "")

//           .toLowerCase()

//           .includes(query);

//       return matchesCourse && matchesSearch;

//     });

//   }, [todaysRows, search, courseFilter]);

//   useEffect(() => {

//     setPage(1);

//   }, [search, courseFilter]);

//   // Pagination.

//   const totalPages = Math.max(

//     1,

//     Math.ceil(filtered.length / PAGE_SIZE)

//   );

//   const safePage = Math.min(page, totalPages);

//   const pageItems = filtered.slice(

//     (safePage - 1) * PAGE_SIZE,

//     safePage * PAGE_SIZE

//   );

//   const goToPage = (number) => {

//     setPage(Math.min(Math.max(1, number), totalPages));

//   };

//   const pageNumbers = useMemo(() => {

//     const numbers = [];

//     const add = (number) => {

//       if (

//         number >= 1 &&

//         number <= totalPages &&

//         !numbers.includes(number)

//       ) {

//         numbers.push(number);

//       }

//     };

//     add(1);

//     add(safePage - 1);

//     add(safePage);

//     add(safePage + 1);

//     add(totalPages);

//     return numbers.sort((a, b) => a - b);

//   }, [safePage, totalPages]);

//   return (

//     <div className="admin-page-full d-flex">

//       <AdminSidebar />

//       <div className="admin-content">

//         <AdminTopbar />

//         <main className="tdy-page">

//           {/* Page header */}

//           <div className="tdy-head">

//             <div>

//               <h2 className="tdy-title">Today's Exams</h2>

//               <p className="tdy-sub">

//                 Students attending an exam today

//               </p>

//             </div>

//             <div className="tdy-head-right">

//               <span className="tdy-date-pill">

//                 <i

//                   className="bi bi-calendar-day"

//                   aria-hidden="true"

//                 />

//                 {prettyToday}

//               </span>

//               <button

//                 type="button"

//                 className="btn btn-primary btn-sm tdy-refresh"

//                 onClick={load}

//                 disabled={loading}

//               >

//                 <i

//                   className={`bi bi-arrow-clockwise ${

//                     loading ? "tdy-spin" : ""

//                   }`}

//                   aria-hidden="true"

//                 />{" "}

//                 Refresh

//               </button>

//             </div>

//           </div>

//           {/* Error message */}

//           {error && (

//             <div className="alert alert-warning py-2 small" role="alert">

//               {error}{" "}

//               <button

//                 type="button"

//                 className="tdy-error-retry"

//                 onClick={load}

//                 disabled={loading}

//               >

//                 Try again

//               </button>

//             </div>

//           )}

//           {/* Attendees table */}

//           <section className="admin-card tdy-card">

//             <div className="tdy-toolbar">

//               <div className="tdy-toolbar-title">

//                 Attendees

//                 <span className="adm-count">{filtered.length}</span>

//               </div>

//               <div className="tdy-filters">

//                 <label className="tdy-search">

//                   <i className="bi bi-search" aria-hidden="true" />

//                   <span className="visually-hidden">

//                     Search attendees

//                   </span>

//                   <input

//                     type="search"

//                     placeholder="Search name, email or mobile"

//                     value={search}

//                     onChange={(event) => setSearch(event.target.value)}

//                   />

//                 </label>

//                 <select

//                   aria-label="Filter by course"

//                   className="form-select form-select-sm tdy-select"

//                   value={courseFilter}

//                   onChange={(event) =>

//                     setCourseFilter(event.target.value)

//                   }

//                 >

//                   <option value="All">All Courses</option>

//                   {courseOptions.map((course) => (

//                     <option key={course.id} value={course.id}>

//                       {course.name}

//                     </option>

//                   ))}

//                 </select>

//               </div>

//             </div>

//             {loading && (

//               <div className="tdy-state" role="status">

//                 <span className="tdy-loader" />

//                 Loading today's exams...

//               </div>

//             )}

//             {!loading && filtered.length === 0 && (

//               <div className="tdy-state">

//                 <i

//                   className="bi bi-calendar2-x"

//                   aria-hidden="true"

//                 />

//                 <p>

//                   {todaysRows.length === 0

//                     ? "No exams scheduled for today."

//                     : "No students match your filters."}

//                 </p>

//                 {!error && todaysRows.length === 0 && (

//                   <span className="tdy-state-hint">

//                     Today's scheduled exams and registered students will appear here.

//                   </span>

//                 )}

//               </div>

//             )}

//             {!loading && filtered.length > 0 && (

//               <>

//                 <div className="table-responsive">

//                   <table className="table align-middle admin-table tdy-table mb-0">

//                     <thead>

//                       <tr>

//                         <th scope="col" className="tdy-number-col">

//                           #

//                         </th>

//                         <th scope="col">Student</th>

//                         <th scope="col">Mobile</th>

//                         <th scope="col">Course</th>

//                         <th scope="col">Exam Date</th>

//                         <th scope="col">Fee</th>

//                         <th scope="col" className="text-end">

//                           View

//                         </th>

//                       </tr>

//                     </thead>

//                     <tbody>

//                       {pageItems.map((row, index) => {

//                         const purchase = row.purchase;

//                         const studentId = row.student?.id;

//                         return (

//                           <tr

//                             key={

//                               purchase.id ??

//                               `${purchase.userId}-${index}`

//                             }

//                           >

//                             <td className="text-muted">

//                               {(safePage - 1) * PAGE_SIZE + index + 1}

//                             </td>

//                             <td>

//                               <div className="tdy-student">

//                                 <div className="tdy-avatar">

//                                   {initialsOf(row.name)}

//                                 </div>

//                                 <div className="tdy-student-text">

//                                   {row.name ? (

//                                     <div className="tdy-student-name">

//                                       {row.name}

//                                     </div>

//                                   ) : (

//                                     <div className="tdy-student-name tdy-missing">

//                                       Unknown (user #

//                                       {purchase.userId ?? "—"})

//                                     </div>

//                                   )}

//                                   <div className="tdy-student-email">

//                                     {row.student?.email || "—"}

//                                   </div>

//                                 </div>

//                               </div>

//                             </td>

//                             <td className="text-muted">

//                               {row.student?.mobile || "—"}

//                             </td>

//                             <td>

//                               <div className="tdy-exam-name">

//                                 {purchase.courseName ||

//                                   `Course ${purchase.courseId ?? "—"}`}

//                               </div>

//                             </td>

//                             <td>

//                               <span className="admin-status-pill pending">

//                                 <i

//                                   className="bi bi-calendar-day me-1"

//                                   aria-hidden="true"

//                                 />

//                                 Today

//                               </span>

//                             </td>

//                             <td>

//                               ₹

//                               {Number(

//                                 purchase.fee || 0

//                               ).toLocaleString("en-IN")}

//                             </td>

//                             <td className="text-end">

//                               {studentId != null && (

//                                 <button

//                                   type="button"

//                                   className="btn btn-sm btn-outline-secondary"

//                                   title="View student"

//                                   aria-label={`View ${

//                                     row.name || "student"

//                                   } details`}

//                                   onClick={() =>

//                                     navigate(

//                                       `/admin/students/${studentId}`

//                                     )

//                                   }

//                                 >

//                                   <i

//                                     className="bi bi-eye"

//                                     aria-hidden="true"

//                                   />

//                                 </button>

//                               )}

//                             </td>

//                           </tr>

//                         );

//                       })}

//                     </tbody>

//                   </table>

//                 </div>

//                 {/* Pagination */}

//                 <div className="tdy-footer">

//                   <span className="text-muted small">

//                     Showing {(safePage - 1) * PAGE_SIZE + 1}–

//                     {Math.min(

//                       safePage * PAGE_SIZE,

//                       filtered.length

//                     )}{" "}

//                     of {filtered.length}

//                   </span>

//                   <nav aria-label="Today's exams pagination">

//                     <ul className="pagination pagination-sm mb-0">

//                       <li

//                         className={`page-item ${

//                           safePage === 1 ? "disabled" : ""

//                         }`}

//                       >

//                         <button

//                           type="button"

//                           className="page-link"

//                           disabled={safePage === 1}

//                           onClick={() => goToPage(safePage - 1)}

//                           aria-label="Previous page"

//                         >

//                           <i

//                             className="bi bi-chevron-left"

//                             aria-hidden="true"

//                           />

//                         </button>

//                       </li>

//                       {pageNumbers.map((number, index) => {

//                         const previous = pageNumbers[index - 1];

//                         const hasGap =

//                           previous !== undefined &&

//                           number - previous > 1;

//                         return (

//                           <React.Fragment key={number}>

//                             {hasGap && (

//                               <li

//                                 className="page-item disabled"

//                                 aria-hidden="true"

//                               >

//                                 <span className="page-link">…</span>

//                               </li>

//                             )}

//                             <li

//                               className={`page-item ${

//                                 number === safePage ? "active" : ""

//                               }`}

//                             >

//                               <button

//                                 type="button"

//                                 className="page-link"

//                                 aria-current={

//                                   number === safePage

//                                     ? "page"

//                                     : undefined

//                                 }

//                                 onClick={() => goToPage(number)}

//                               >

//                                 {number}

//                               </button>

//                             </li>

//                           </React.Fragment>

//                         );

//                       })}

//                       <li

//                         className={`page-item ${

//                           safePage === totalPages ? "disabled" : ""

//                         }`}

//                       >

//                         <button

//                           type="button"

//                           className="page-link"

//                           disabled={safePage === totalPages}

//                           onClick={() => goToPage(safePage + 1)}

//                           aria-label="Next page"

//                         >

//                           <i

//                             className="bi bi-chevron-right"

//                             aria-hidden="true"

//                           />

//                         </button>

//                       </li>

//                     </ul>

//                   </nav>

//                 </div>

//               </>

//             )}

//           </section>

//         </main>

//       </div>

//     </div>

//   );

// }

import React, {

  useCallback,

  useEffect,

  useMemo,

  useState,

} from "react";


import AdminSidebar from "./AdminSidebar";

import AdminTopbar from "./Admintopbar";

import {

  getStudents,

  getSchedules,

  getAdminRegistrations,

  getAdminExams,


  normalizeDate,

  getStudentDisplayName,

} from "../api/adminclient";

const PAGE_SIZE = 10;

const todayISO = () => {

  const date = new Date();

  const month = String(date.getMonth() + 1).padStart(2, "0");

  const day = String(date.getDate()).padStart(2, "0");

  return `${date.getFullYear()}-${month}-${day}`;

};

const initialsOf = (name) =>

  (name || "?")

    .split(/\s+/)

    .filter(Boolean)

    .slice(0, 2)

    .map((part) => part[0].toUpperCase())

    .join("") || "?";

export default function AdminTodaysExams() {


  const [purchases, setPurchases] = useState([]);

  const [students, setStudents] = useState([]);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");

  const [search, setSearch] = useState("");

  const [courseFilter, setCourseFilter] = useState("All");

  const [page, setPage] = useState(1);

  const prettyToday = new Date().toLocaleDateString(undefined, {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  // Load bookings and students from the existing API client.

  const load = useCallback(async () => {

  setLoading(true);

  setError("");

  try {

    const [

      studentsResponse,

      schedulesResponse,

      registrationsResponse,

      examsResponse,


    ] = await Promise.all([

      getStudents(),

      getSchedules(),

      getAdminRegistrations(),

      getAdminExams(),


    ]);

    const toArray = (response) => {

      const data = response?.data;

      if (Array.isArray(data)) return data;

      if (Array.isArray(data?.results)) return data.results;

      return [];

    };

    setStudents(toArray(studentsResponse));

    // Build booking rows from Django registrations and schedules.

    const schedules = toArray(schedulesResponse);

    const registrations = toArray(registrationsResponse);

    const exams = toArray(examsResponse);


    const getRelatedId = (value) => {

      if (value && typeof value === "object") {

        return value.id ?? value.pk ?? value.examId ?? value.exam_id ?? null;

      }

      return value ?? null;

    };

    const getScheduleId = (registration) =>

      getRelatedId(

        registration.schedule ??

        registration.scheduleId ??

        registration.schedule_id

      );

    const getStudentId = (registration) =>

      getRelatedId(

        registration.student ??

        registration.studentId ??

        registration.student_id ??

        registration.user ??

        registration.userId ??

        registration.user_id

      );

    const getExamId = (record) =>

      getRelatedId(

        record.exam ??

        record.examId ??

        record.exam_id

      );

    const getScheduleDate = (schedule) =>

      normalizeDate(

        schedule.exam_date ??

        schedule.examDate ??

        schedule.date

      );

    const today = todayISO();

    const rows = registrations

      .map((registration) => {

        const scheduleId = getScheduleId(registration);

        const schedule = schedules.find(

          (item) =>

            String(item.id ?? item.pk) === String(scheduleId)

        );

        if (!schedule || getScheduleDate(schedule) !== today) {

          return null;

        }

        const examId = getExamId(schedule);

        const exam =

          exams.find(

            (item) =>

              String(item.id ?? item.pk) === String(examId)

          ) ??

          (schedule.exam && typeof schedule.exam === "object"

            ? schedule.exam

            : null);

        const studentId = getStudentId(registration);

        const student =

          studentsResponse &&

          toArray(studentsResponse).find(

            (item) =>

              String(item.id ?? item.pk) === String(studentId)

          );

        return {

          id: registration.id ?? registration.pk,

          userId: studentId,

          studentName: student

            ? getStudentDisplayName(student)

            : registration.studentName ??

              registration.student_name ??

              "",

          studentEmail: student?.email ?? registration.email ?? "",

          mobile: student?.mobile ?? registration.mobile ?? "",

          courseId: exam?.courseId ?? exam?.course_id ?? "",

          courseName:

            exam?.name ??

            exam?.title ??

            schedule.exam_name ??

            schedule.examName ??

            "Scheduled Exam",

          examDate: getScheduleDate(schedule),

          registration,

          schedule,

        };

      })

      .filter(Boolean);

    setPurchases(rows);

  } catch (err) {

    console.error("Today's Exams Django API error:", err);

    console.error("Status:", err.response?.status);

    console.error("Response:", err.response?.data);

    setError(

      err.response

        ? `Django API error ${err.response.status}. Check the failed request in the browser Network tab.`

        : "Cannot connect to Django. Check that the backend server is running."

    );

    setStudents([]);

    setPurchases([]);

  } finally {

    setLoading(false);

  }

}, []);

  // Load Django data when the page first mounts.
  // Without this effect, load() is defined but never called automatically.
  useEffect(() => {
    load();
  }, [load]);

  // Match bookings whose exam date is today.

  const today = todayISO();

const todaysRows = useMemo(() => {

  return purchases

    .filter((purchase) => normalizeDate(purchase.examDate) === today)

    .map((purchase) => {

      const student = students.find(

        (item) =>

          String(item.id ?? item.pk) === String(purchase.userId)

      );

      return {

        purchase,

        student: student ?? {

          id: purchase.userId,

          email: purchase.studentEmail,

          mobile: purchase.mobile,

          fullName: purchase.studentName,

        },

        name:

          purchase.studentName ||

          (student ? getStudentDisplayName(student) : null),

      };

    });

}, [purchases, students, today]);

  // Build the course dropdown from today's bookings.

  const courseOptions = useMemo(() => {

    const courseMap = new Map();

    todaysRows.forEach(({ purchase }) => {

      const id = String(

        purchase.courseId ?? purchase.courseName ?? "unknown"

      );

      if (!courseMap.has(id)) {

        courseMap.set(id, {

          id,

          name: purchase.courseName || `Course ${id}`,

        });

      }

    });

    return Array.from(courseMap.values());

  }, [todaysRows]);

  // Search by student name, email, mobile, or course.

  const filtered = useMemo(() => {

    const query = search.trim().toLowerCase();

    return todaysRows.filter((row) => {

      const courseId = String(

        row.purchase.courseId ?? row.purchase.courseName ?? "unknown"

      );

      const matchesCourse =

        courseFilter === "All" || courseId === courseFilter;

      const matchesSearch =

        !query ||

        row.name?.toLowerCase().includes(query) ||

        row.student?.email?.toLowerCase().includes(query) ||

        String(row.student?.mobile ?? "").includes(query) ||

        String(row.purchase.courseName ?? "")

          .toLowerCase()

          .includes(query);

      return matchesCourse && matchesSearch;

    });

  }, [todaysRows, search, courseFilter]);

  useEffect(() => {

    setPage(1);

  }, [search, courseFilter]);

  // Pagination.

  const totalPages = Math.max(

    1,

    Math.ceil(filtered.length / PAGE_SIZE)

  );

  const safePage = Math.min(page, totalPages);

  const pageItems = filtered.slice(

    (safePage - 1) * PAGE_SIZE,

    safePage * PAGE_SIZE

  );

  const goToPage = (number) => {

    setPage(Math.min(Math.max(1, number), totalPages));

  };

  const pageNumbers = useMemo(() => {

    const numbers = [];

    const add = (number) => {

      if (

        number >= 1 &&

        number <= totalPages &&

        !numbers.includes(number)

      ) {

        numbers.push(number);

      }

    };

    add(1);

    add(safePage - 1);

    add(safePage);

    add(safePage + 1);

    add(totalPages);

    return numbers.sort((a, b) => a - b);

  }, [safePage, totalPages]);

  return (

    <div className="admin-page-full d-flex">

      <AdminSidebar />

      <div className="admin-content">

        <AdminTopbar />

        <main className="tdy-page">

          {/* Page header */}

          <div className="tdy-head">

            <div>

              <h2 className="tdy-title">Today's Exams</h2>

              <p className="tdy-sub">

                Students attending an exam today

              </p>

            </div>

            <div className="tdy-head-right">

              <span className="tdy-date-pill">

                <i

                  className="bi bi-calendar-day"

                  aria-hidden="true"

                />

                {prettyToday}

              </span>

              <button

                type="button"

                className="btn btn-primary btn-sm tdy-refresh"

                onClick={load}

                disabled={loading}

              >

                <i

                  className={`bi bi-arrow-clockwise ${

                    loading ? "tdy-spin" : ""

                  }`}

                  aria-hidden="true"

                />{" "}

                Refresh

              </button>

            </div>

          </div>

          {/* Error message */}

          {error && (

            <div className="alert alert-warning py-2 small" role="alert">

              {error}{" "}

              <button

                type="button"

                className="tdy-error-retry"

                onClick={load}

                disabled={loading}

              >

                Try again

              </button>

            </div>

          )}

          {/* Attendees table */}

          <section className="admin-card tdy-card">

            <div className="tdy-toolbar">

              <div className="tdy-toolbar-title">

                Attendees

                <span className="adm-count">{filtered.length}</span>

              </div>

              <div className="tdy-filters">

                <label className="tdy-search">

                  <i className="bi bi-search" aria-hidden="true" />

                  <span className="visually-hidden">

                    Search attendees

                  </span>

                  <input

                    type="search"

                    placeholder="Search name, email or mobile"

                    value={search}

                    onChange={(event) => setSearch(event.target.value)}

                  />

                </label>

                <select

                  aria-label="Filter by course"

                  className="form-select form-select-sm tdy-select"

                  value={courseFilter}

                  onChange={(event) =>

                    setCourseFilter(event.target.value)

                  }

                >

                  <option value="All">All Courses</option>

                  {courseOptions.map((course) => (

                    <option key={course.id} value={course.id}>

                      {course.name}

                    </option>

                  ))}

                </select>

              </div>

            </div>

            {loading && (

              <div className="tdy-state" role="status">

                <span className="tdy-loader" />

                Loading today's exams...

              </div>

            )}

            {!loading && filtered.length === 0 && (

              <div className="tdy-state">

                <i

                  className="bi bi-calendar2-x"

                  aria-hidden="true"

                />

                <p>

                  {todaysRows.length === 0

                    ? "No exams scheduled for today."

                    : "No students match your filters."}

                </p>

                {!error && todaysRows.length === 0 && (

                  <span className="tdy-state-hint">

                    Today's scheduled exams and registered students will appear here.

                  </span>

                )}

              </div>

            )}

            {!loading && filtered.length > 0 && (

              <>

                <div className="table-responsive">

                  <table className="table align-middle admin-table tdy-table mb-0">

                    <thead>

                      <tr>

                        <th scope="col" className="tdy-number-col">

                          #

                        </th>

                        <th scope="col">Student</th>

                        <th scope="col">Mobile</th>

                        <th scope="col">Course</th>

                        <th scope="col">Exam Date</th>

                        <th scope="col">Fee</th>

                      </tr>

                    </thead>

                    <tbody>

                      {pageItems.map((row, index) => {

                        const purchase = row.purchase;


                        return (

                          <tr

                            key={

                              purchase.id ??

                              `${purchase.userId}-${index}`

                            }

                          >

                            <td className="text-muted">

                              {(safePage - 1) * PAGE_SIZE + index + 1}

                            </td>

                            <td>

                              <div className="tdy-student">

                                <div className="tdy-avatar">

                                  {initialsOf(row.name)}

                                </div>

                                <div className="tdy-student-text">

                                  {row.name ? (

                                    <div className="tdy-student-name">

                                      {row.name}

                                    </div>

                                  ) : (

                                    <div className="tdy-student-name tdy-missing">

                                      Unknown (user #

                                      {purchase.userId ?? "—"})

                                    </div>

                                  )}

                                  <div className="tdy-student-email">

                                    {row.student?.email || "—"}

                                  </div>

                                </div>

                              </div>

                            </td>

                            <td className="text-muted">

                              {row.student?.mobile || "—"}

                            </td>

                            <td>

                              <div className="tdy-exam-name">

                                {purchase.courseName ||

                                  `Course ${purchase.courseId ?? "—"}`}

                              </div>

                            </td>

                            <td>

                              <span className="admin-status-pill pending">

                                <i

                                  className="bi bi-calendar-day me-1"

                                  aria-hidden="true"

                                />

                                Today

                              </span>

                            </td>

                            <td>

                              ₹

                              {Number(

                                purchase.fee || 0

                              ).toLocaleString("en-IN")}

                            </td>

                          </tr>

                        );

                      })}

                    </tbody>

                  </table>

                </div>

                {/* Pagination */}

                <div className="tdy-footer">

                  <span className="text-muted small">

                    Showing {(safePage - 1) * PAGE_SIZE + 1}–

                    {Math.min(

                      safePage * PAGE_SIZE,

                      filtered.length

                    )}{" "}

                    of {filtered.length}

                  </span>

                  <nav aria-label="Today's exams pagination">

                    <ul className="pagination pagination-sm mb-0">

                      <li

                        className={`page-item ${

                          safePage === 1 ? "disabled" : ""

                        }`}

                      >

                        <button

                          type="button"

                          className="page-link"

                          disabled={safePage === 1}

                          onClick={() => goToPage(safePage - 1)}

                          aria-label="Previous page"

                        >

                          <i

                            className="bi bi-chevron-left"

                            aria-hidden="true"

                          />

                        </button>

                      </li>

                      {pageNumbers.map((number, index) => {

                        const previous = pageNumbers[index - 1];

                        const hasGap =

                          previous !== undefined &&

                          number - previous > 1;

                        return (

                          <React.Fragment key={number}>

                            {hasGap && (

                              <li

                                className="page-item disabled"

                                aria-hidden="true"

                              >

                                <span className="page-link">…</span>

                              </li>

                            )}

                            <li

                              className={`page-item ${

                                number === safePage ? "active" : ""

                              }`}

                            >

                              <button

                                type="button"

                                className="page-link"

                                aria-current={

                                  number === safePage

                                    ? "page"

                                    : undefined

                                }

                                onClick={() => goToPage(number)}

                              >

                                {number}

                              </button>

                            </li>

                          </React.Fragment>

                        );

                      })}

                      <li

                        className={`page-item ${

                          safePage === totalPages ? "disabled" : ""

                        }`}

                      >

                        <button

                          type="button"

                          className="page-link"

                          disabled={safePage === totalPages}

                          onClick={() => goToPage(safePage + 1)}

                          aria-label="Next page"

                        >

                          <i

                            className="bi bi-chevron-right"

                            aria-hidden="true"

                          />

                        </button>

                      </li>

                    </ul>

                  </nav>

                </div>

              </>

            )}

          </section>

        </main>

      </div>

    </div>

  );

}